import {faFaceSmile} from '@fortawesome/pro-regular-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Popover, Tooltip} from 'antd';
import EmojiPicker, {EmojiClickData, EmojiStyle, Theme} from 'emoji-picker-react';
import {memo, useMemo, useState} from 'react';

import {useLocale} from '../../../../provider/locale/locale-hook';
import {Locale} from '../../../../provider/locale/localization';
import {useSystem} from '../../../../provider/system/system-hook';
import {classNames} from '../../../../util/css';

import {EMOJI_PICKER_HEIGHT, EMOJI_PICKER_WIDTH, getEmojiPickerDataByLocale} from './review-reply-emoji-picker-const';
import {ReviewReplyEmojiPickerPropsType} from './review-reply-emoji-picker-types';
import * as styles from './review-reply-emoji-picker.module.scss';

export const ReviewReplyEmojiPicker = memo(function ReviewReplyEmojiPickerInner(
    props: ReviewReplyEmojiPickerPropsType
): JSX.Element | null {
    const {disabled, onEmojiSelect} = props;

    const {screen} = useSystem();
    const {localeName} = useLocale();
    const [isOpen, setIsOpen] = useState<boolean>(false);

    const emojiData = useMemo(() => getEmojiPickerDataByLocale(localeName), [localeName]);

    if (screen.isMobile) {
        return null;
    }

    function handleEmojiClick(emojiClickData: EmojiClickData): void {
        onEmojiSelect(emojiClickData.emoji);
    }

    return (
        <Popover
            content={
                <div className={styles.ReviewReplyEmojiPicker_pickerContent}>
                    <EmojiPicker
                        autoFocusSearch={false}
                        className={styles.ReviewReplyEmojiPicker_picker}
                        emojiData={emojiData}
                        emojiStyle={EmojiStyle.APPLE}
                        height={EMOJI_PICKER_HEIGHT}
                        lazyLoadEmojis
                        onEmojiClick={handleEmojiClick}
                        previewConfig={{showPreview: false}}
                        searchDisabled
                        skinTonesDisabled
                        theme={Theme.LIGHT}
                        width={EMOJI_PICKER_WIDTH}
                    />
                </div>
            }
            destroyTooltipOnHide
            getPopupContainer={(triggerNode) => triggerNode.ownerDocument.body}
            onOpenChange={setIsOpen}
            open={isOpen}
            overlayClassName={styles.ReviewReplyEmojiPicker_popover}
            placement="bottomRight"
            trigger="click"
        >
            <span
                className={styles.ReviewReplyEmojiPicker_trigger}
                onMouseDown={(event) => {
                    event.stopPropagation();
                }}
                role="presentation"
            >
                <Tooltip placement="top" title={<Locale stringKey="REVIEWS__REPLY__EMOJI_PICKER__HINT" />}>
                    <button
                        className={classNames(styles.ReviewReplyEmojiPicker_emojiButton)}
                        disabled={disabled}
                        onMouseDown={(event) => {
                            event.stopPropagation();
                        }}
                        type="button"
                    >
                        <FontAwesomeIcon icon={faFaceSmile} />
                    </button>
                </Tooltip>
            </span>
        </Popover>
    );
});
